<div class="modal-header">
  <h4 class="modal-title">
    {{ 'articleActions.action.label.editEmptyZone' | translate }}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form" >
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label font-weight-bold">{{'settingsTabNavigator.label.article_length' | translate}}: *</label>
        <div class="col-md-8">
          <input class="form-control" type="text"
                 spellcheck="false"
                 inputRestricter="^[0-9\.,]*$"
                 [readonly]="readonly"
                 formControlName="articleLength"
                 [class.is-invalid]="form.controls.articleLength.invalid"
                 (inputEvent)="form.controls.articleLength.setValue($event)">
          <div class="invalid-feedback">
            {{form.controls.articleLength.errors?.messageKey | translate}}
          </div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label font-weight-bold">{{'settingsTabNavigator.label.leading_measurement' | translate}}: </label>
        <div class="col-md-8 col-form-label">
          <div class="form-check">
            <input class="form-check-input" type="checkbox"
                   id="dimensions"
                   [attr.disabled]="readonly"
                   formControlName="isLeadingValue">
            <label for="dimensions" class="form-check-label">{{'settingsTabNavigator.label.is_leading_value' | translate}}</label>
          </div>
        </div>
      </div>
      <div class="invalid-feedback" [class.d-block]="form.errors?.relocationValidError">
        {{'settingsTabNavigator.validation.error.blocking_zone' | translate}}
      </div>
    </form>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{readonly ? ('global.label.ok' | translate) : ('global.label.cancel' | translate)}}
  </button>
  <button type="submit" class="btn btn-primary btn-forward" (click)="saveButton_clickHandler()" [disabled]="form.invalid" *ngIf="!readonly">
    {{'global.label.save' | translate}}
  </button>
</div>
